export const rootPath = () => "/";
export const signInPath = () => "/signin";
export const signUpPath = () => "/signup";
export const dashboardPath = () => "/dashboard";
export const projectsPath = () => "/projects";
export const projectSubgraphsPath = (projectId: string) => `/projects/${projectId}/subgraphs`;
export const projectSubgraphsV2Path = (projectId: string) => `/projects/${projectId}/subgraphs-v2`;
export const projectEndpointsPath = (id: string) => `/projects/${id}/endpoints`;
export const projectCollaboratorsPath = (id: string) => `/projects/${id}/collaborators`;
export const projectSettingsPath = (id: string) => `/projects/${id}/settings`;
export const projectEndpointPath = (
  projectId: string,
  chain: string,
  network: string,
  nodeType: string,
) => `/projects/${projectId}/endpoints/${chain}/${network}/${nodeType}`;
export const createSubgraphPath = () => `/projects/subgraphs/create`;
export const createSubgraphV2Path = () => `/projects/subgraphs-v2/create`;
export const subgraphDetailPath = (projectId: string, subgraphId: string) =>
  `/projects/${projectId}/subgraphs/${subgraphId}`;
export const subgraphV2DetailPath = (projectId: string, subgraphId: string) =>
  `/projects/${projectId}/subgraphs-v2/${subgraphId}`;
export const profilePath = () => "/profile";
export const docsPath = () => "/docs";
